
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { RootFolder } from "@/pages/Common/types";
export default defineComponent({
  computed: {
    ...mapState("datasources", ["currentFolder"]),
    rootFolderId(): string {
      return RootFolder.id;
    },
  },
  props: {
    workspaceId: {
      type: String,
    },
  },
});
